import type { Board } from "../board";
import { CollectableItem, type CollectablePickupResult } from "../collectableItem";
import type { Player } from "../player";

export class Gold extends CollectableItem {
	static key = "Gold";

	pickupBy(player: Player, board: Board): CollectablePickupResult {
		player.gold += this.count;
		board.stats.recordGoldCollected(this.count);
		return { pickupKey: Gold.key, amount: this.count, isInfinite: false };
	}

	static deserialize(data: any): Gold {
		return new Gold(data.count);
	}
}
